import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ticketNumber'
})
export class TicketNumberPipe implements PipeTransform {
  transform(value: number): string {
    return `#${value.toString().padStart(6, '0')}`;
  }
}
